"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrafficTypeInitialized = exports.areAllSplitClientsInitialized = exports.isSplitClientAnonymousTrafficTypeInitialized = exports.isSplitClientMagentoTrafficTypeInitialized = void 0;
const browser_1 = require("../../helpers/browser");
const log_1 = require("../../helpers/log");
const constants_1 = require("./constants");
// Traffic typed client validations
const isSplitClientMagentoTrafficTypeInitialized = (verifyClientsCredentials, magentoClientCredentials) => {
  if ((0, browser_1.isServerSideRendering)()) return false;
  const magentoClientStored = typeof window.magentoSplitClient !== 'undefined';
  // Given the magento client flow in Gatsby, we need to add certain validations
  const isInitialized = verifyClientsCredentials ? !!(magentoClientCredentials === null || magentoClientCredentials === void 0 ? void 0 : magentoClientCredentials.splitMagentoEmail) && !!(magentoClientCredentials === null || magentoClientCredentials === void 0 ? void 0 : magentoClientCredentials.splitMagentoUserKey) && magentoClientStored : !!magentoClientStored;
  if (isInitialized) {
    (0, log_1.debugLog)('Magento traffic type split client is initialized');
  } else {
    (0, log_1.debugLog)('Magento traffic type split client is NOT initialized');
  }
  return isInitialized;
};
exports.isSplitClientMagentoTrafficTypeInitialized = isSplitClientMagentoTrafficTypeInitialized;
const isSplitClientAnonymousTrafficTypeInitialized = (verifyClientsCredentials, anonymousClientCredentials) => {
  if ((0, browser_1.isServerSideRendering)()) return false;
  const anonymousClientStored = typeof window.anonymousSplitClient !== 'undefined';
  // Given the anonymous client flow in Gatsby, we need to add certain validations
  const isInitialized = verifyClientsCredentials ? !!(anonymousClientCredentials === null || anonymousClientCredentials === void 0 ? void 0 : anonymousClientCredentials.splitAnonymousUserKey) && anonymousClientStored : !!anonymousClientStored;
  if (isInitialized) {
    (0, log_1.debugLog)('Anonymous traffic type split client is initialized');
  } else {
    (0, log_1.debugLog)('Anonymous traffic type split client is NOT initialized');
  }
  return isInitialized;
};
exports.isSplitClientAnonymousTrafficTypeInitialized = isSplitClientAnonymousTrafficTypeInitialized;
const areAllSplitClientsInitialized = verifyClientsCredentials => (0, exports.isSplitClientAnonymousTrafficTypeInitialized)(verifyClientsCredentials) && (0, exports.isSplitClientMagentoTrafficTypeInitialized)(verifyClientsCredentials);
exports.areAllSplitClientsInitialized = areAllSplitClientsInitialized;
const isTrafficTypeInitialized = trafficType => {
  const trafficTypeChecker = {
    [constants_1.SPLIT_TRAFFIC_TYPES.ANONYMOUS]: exports.isSplitClientAnonymousTrafficTypeInitialized,
    [constants_1.SPLIT_TRAFFIC_TYPES.MAGENTO]: exports.isSplitClientMagentoTrafficTypeInitialized
  };
  if (trafficTypeChecker[trafficType]) {
    return trafficTypeChecker[trafficType]();
  }
  throw new Error(`Invalid traffic type: ${trafficType} provided. Traffic type must be one of: ${Object.keys(trafficTypeChecker).join(', ')}`);
};
exports.isTrafficTypeInitialized = isTrafficTypeInitialized;